export const LEAGUES = [
  { code: "MLB", label: "MLB", country: "USA" },
  { code: "NPB", label: "NPB", country: "Japan" },
  { code: "LMB", label: "LMB", country: "Mexico" },
  { code: "CPB", label: "CPBL", country: "Taiwan" },
  { code: "LMP", label: "LMP", country: "Mexico" },
  { code: "KBO", label: "KBO", country: "South Korea" },
  { code: "NFL", label: "NFL", country: "USA" },
  { code: "NBA", label: "NBA", country: "USA" },
];
